export enum SettingsPageSections {
  PROFILE = 'profile',
  TEAM = 'team',
  WORKSPACE_SETTINGS = 'workspace_settings',
  MODEL_MANAGEMENT = 'model_management',
  BILLING = 'billing',
}
